import { RD_BASE } from './config';

/**
 * 网站流量估算（走 Monid → Semrush /trends_summary，$0.06/次，24h 缓存）。
 * @param {string} domain  裸域名，如 "uniswap.org"（不带协议/路径）
 * @returns {Promise<{rank, visits, users, pages_per_visit, time_on_site, bounce_rate, desktop_share, mobile_share}|null>}
 */
export async function getWebsiteTraffic(domain) {
  if (!domain) return null;
  try {
    const res = await fetch(`${RD_BASE}/api/monid/website-traffic?domain=${encodeURIComponent(domain)}`);
    if (!res.ok) return null;
    const data = await res.json();
    return data.ok ? (data.traffic || null) : null;
  } catch {
    return null;
  }
}

/**
 * LinkedIn 人员搜索（走 Monid → Apify linkedin-profile-search-by-name，$0.015/条，
 * 封顶 5 条 = 最多 $0.075/次，异步约 5-15 秒，24h 缓存）。
 * @param {string} fullName  完整姓名，需要包含空格分隔的姓+名，如 "Satya Nadella"
 * @returns {Promise<Array<{name, position, location, linkedinUrl, publicIdentifier}>>}
 */
export async function searchLinkedInPerson(fullName) {
  if (!fullName || !fullName.trim().includes(' ')) return [];
  try {
    const res = await fetch(`${RD_BASE}/api/monid/linkedin-search?name=${encodeURIComponent(fullName.trim())}`);
    if (!res.ok) return [];
    const data = await res.json();
    return data.ok ? (data.people || []) : [];
  } catch {
    return [];
  }
}
